import { renderSlot as _renderSlot, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "modal-global" }
const _hoisted_2 = { class: "modal-global__modal" }
const _hoisted_3 = { class: "modal-global__modal__body" }
const _hoisted_4 = { class: "modal-global__modal__body__desc" }
const _hoisted_5 = { class: "modal-global__modal__footer" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "text-second" }, "확인", -1)
const _hoisted_7 = [
  _hoisted_6
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("article", _hoisted_3, [
        _createElementVNode("pre", _hoisted_4, [
          _createTextVNode("          "),
          _renderSlot(_ctx.$slots, "description"),
          _createTextVNode("\n        ")
        ])
      ]),
      _createElementVNode("footer", _hoisted_5, [
        (!_ctx.isShowCancel)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$emit('onCancel')), ["stop"])),
              class: "cs-btn cs-btn-clear py-3 px-8 mr-8"
            }, "취소"))
          : _createCommentVNode("", true),
        _createElementVNode("button", {
          onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.$emit('onConfirm')), ["stop"])),
          class: "cs-btn cs-btn-clear py-3 px-8"
        }, _hoisted_7)
      ])
    ])
  ]))
}